import { useQuery } from '@tanstack/react-query';

import { sortingOptionsQueryOptions } from '../data-provider';

export const useSortingOptions = () => {
  return useQuery(sortingOptionsQueryOptions());
};
